import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import DummyContent from '../../primitive/DummyContent';
import DummyRectangle from '../../primitive/DummyRectangle';

interface Props {
  className?: string;
}

const DummyProjectTypeSummary = ({ className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <Heading length={30} />
    <SampleScreen />
    <Title />
    <Description />
  </Root>
);

export const Root = styled('div')(
  gridLayoutContainer({
    columns: ['1fr', `${SPACING_UNIT * 3}px`, '1fr'],
    rows: ['auto', 'auto', '1fr'],
    areas: [
      ['heading', 'heading', 'heading'],
      ['sample', '.', 'title'],
      ['sample', '.', 'description'],
    ],
  }),
);

const Heading = styled(DummyContent)(gridLayoutItem('heading'), { marginBottom: SPACING_UNIT * 3 });

const SampleScreen = styled(DummyRectangle)(gridLayoutItem('sample', { justifySelf: 'center' }), {
  width: '100%',
  height: '330px',
});

const Title = styled(DummyContent)(gridLayoutItem('title'), { marginBottom: SPACING_UNIT });

const Description = styled(DummyContent)(gridLayoutItem('description'));

export default DummyProjectTypeSummary;
